import { createSelector } from '@reduxjs/toolkit';

export const getVouchersState = (state) => state.vouchers;
export const getVoucherState = (state) => state.voucher;

export const getVouchers = createSelector(getVouchersState, (vouchersState) => vouchersState.data);
